import { StyleSheet } from 'react-native'

export default StyleSheet.create({
  redDotStyle: theme => ({
    width: 18,
    borderRadius: 9,
    height: 18,
    padding: 0,
    backgroundColor: theme.colors.activeTabColorTwo,
  }),
  outerDotStyle: theme => ({
    width: 24,
    borderRadius: 12,
    height: 24,
    borderWidth: 1,
    padding: 0,
    borderColor: theme.colors.activeTabColorTwo,
    justifyContent: 'center',
  }),
  innerDotStyle: theme => ({
    alignSelf: 'center',
    width: 18,
    borderRadius: 9,
    height: 18,
    backgroundColor: theme.colors.activeTabColorTwo,
  }),
  greyDotStyle: theme => ({
    width: 18,
    borderRadius: 9,
    height: 18,
    backgroundColor: theme.colors.inActiveDot,
  }),
})
